import { useMemo, type ReactElement } from 'react'
import logo from '../../assets/images/logo.png'
import logoColor from '../../assets/images/logo-positvo.png'
import * as S from './header.styled'
import { PhoneNumber } from '../phone-number/phone-number'
import { type HeaderProps } from './header.props'
import { Link } from 'react-router-dom'
import { LinkButton } from '../button/link-button'

export default function Header ({ className }: HeaderProps): ReactElement {
  const logoImage = useMemo(() => {
    if (className === 'blank') return logoColor
    return logo
  }, [className])

  return <S.Container className={className}>
    <S.Content>
      <figure>
        <img src={logoImage} alt="Logo Cartão de Todos" />
      </figure>

      {!className && <LinkButton to="https://idpv.cartaodetodos.com.br/dados-pessoais/?from_lead=1&idpv=593fe813-3579-442f-b0c2-17a883e92e24">Peça o seu cartão!</LinkButton>}
      {className === 'blank' && <Link to="tel:08007292072"><PhoneNumber>0800 729 2072</PhoneNumber></Link>}
    </S.Content>
  </S.Container>
}
